import {
  Button,
  Divider,
  Grid,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Box } from "@mui/system";
import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";

function PortfolioTradeBox({ portfolioTradeItem }) {
  const theme = useTheme();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const portfolioType = +searchParams.get("portfolioType") || 0;

  return (
    <Card shadow={theme.shadows[1]} maxHeight="initial">
      <Box
        key={portfolioTradeItem.id}
        onClick={() => {
          navigate(
            `/portfolio-details/${portfolioType}/${portfolioTradeItem.id}`
          );
        }}
      >
        <Grid
          pb={1}
          container
          display="flex"
          flexDirection="row-reverse"
          alignItems="center"
        >
          <Grid item xs={2} display="flex" justifyContent="center">
            <img
              width="30px"
              src={`${DefaultUrlWeb}${portfolioTradeItem.imageUrl}`}
              alt={portfolioTradeItem.name}
            />
          </Grid>

          <Grid item xs={10} pl={2}>
            <Box py={1}>
              <Typography
                component="span"
                variant="h5"
                color="text.secondary"
                display="flex"
                dir="ltr"
              >
                Balance:
                <Typography variant="h5" color="text.main" pl={0.5}>
                  <NumberFormats
                    displayType={"text"}
                    value={portfolioTradeItem.totalBalance}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" pl={0.5}>
                  {portfolioTradeItem.name}
                </Typography>
              </Typography>
            </Box>

            <DividerStyle width={"100%"} />

            <Box py={1}>
              <Typography
                component="span"
                variant="h5"
                color="text.secondary"
                display="flex"
                dir="ltr"
              >
                Value Blnc:
                <Typography variant="h5" color="text.main" pl={0.5}>
                  <NumberFormats
                    displayType={"text"}
                    value={portfolioTradeItem.costMarketUSDT}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" pl={0.5}>
                  USDT
                </Typography>
              </Typography>
            </Box>

            <Box py={1}>
              <Typography
                component="span"
                variant="h5"
                color="text.secondary"
                display="flex"
                dir="ltr"
              >
                Value Blnc:
                <Typography variant="h5" color="text.main" pl={0.5}>
                  <NumberFormats
                    displayType={"text"}
                    value={portfolioTradeItem.costMarketToman}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" pl={0.5}>
                  TOMAN
                </Typography>
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <DividerStyle width={"100%"} />

        <Grid container display="flex" flexDirection="row-reverse" pt={2}>
          <Grid item xs={2} dir="ltr">
            <Typography variant="h5" color="success.main">
              Buy Average
            </Typography>
          </Grid>
          <Grid item xs={10} pl={4}>
            <BoxAverage>
              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.buyFilled}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    {portfolioTradeItem.name}
                  </Typography>
                </Typography>
              </Box>

              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.buyAvgToman}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    Toman
                  </Typography>
                </Typography>
              </Box>

              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.buyAvgUSDT}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    USDT
                  </Typography>
                </Typography>
              </Box>
            </BoxAverage>
          </Grid>
        </Grid>

        <Grid container display="flex" flexDirection="row-reverse" pt={2}>
          <Grid item xs={2} dir="ltr">
            <Typography variant="h5" color="error.main">
              Sell Average
            </Typography>
          </Grid>

          <Grid item xs={10} pl={4}>
            <BoxSell>
              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.sellFilled}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    {portfolioTradeItem.name}
                  </Typography>
                </Typography>
              </Box>

              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.sellAvgToman}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    Toman
                  </Typography>
                </Typography>
              </Box>

              <Box pr={0.5} pl={1}>
                <Typography
                  component="span"
                  variant="h5"
                  color="text.secondary"
                  display="flex"
                  dir="ltr"
                >
                  <Typography variant="h5" color="text.main" pl={0.5}>
                    <NumberFormats
                      displayType={"text"}
                      value={portfolioTradeItem.sellAvgUSDT}
                      thousandSeparator={true}
                    />
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="text.secondary"
                    pl={0.5}
                  >
                    USDT
                  </Typography>
                </Typography>
              </Box>
            </BoxSell>
          </Grid>
        </Grid>

        <Grid container display="flex" flexDirection="row-reverse" py={2}>
          <Grid item xs={2} dir="ltr">
            <Typography variant="h5" color="secondary.main">
              Market Price
            </Typography>
          </Grid>
          <Grid item xs={10} pl={4}>
            <Box py={0.5}>
              <Typography
                component="span"
                variant="h5"
                color="text.secondary"
                display="flex"
                dir="ltr"
              >
                <Typography variant="h5" color="text.main" pl={0.5}>
                  <NumberFormats
                    displayType={"text"}
                    value={portfolioTradeItem.priceMarketUSDT}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" pl={0.5}>
                  USDT
                </Typography>
              </Typography>
            </Box>

            <Box py={0.5}>
              <Typography
                component="span"
                variant="h5"
                color="text.secondary"
                display="flex"
                dir="ltr"
              >
                <Typography variant="h5" color="text.main" pl={0.5}>
                  <NumberFormats
                    displayType={"text"}
                    value={portfolioTradeItem.priceMarketToman}
                    thousandSeparator={true}
                  />
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" pl={0.5}>
                  Toman
                </Typography>
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Button onClick={() => {}} color="success" fullWidth>
          See More
        </Button>
      </Box>
    </Card>
  );
}
const DividerStyle = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.primary.dark,
}));

const BoxAverage = styled(Box)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.success.main}`,
}));
const BoxSell = styled(Box)(({ theme }) => ({
  borderLeft: `2px solid ${theme.palette.error.main}`,
}));
export default PortfolioTradeBox;
